import { lazy } from "react";

import { Routes, Route } from "react-router-dom";

import { HomeLayout } from "../../views/layouts/homelayout";
import { ProtectedLayout } from "../../views/layouts/protectedlayout";
const Landing = lazy(() => import("@pages/landing/landing"));
const StartProbate = lazy(() => import("@pages/startprobate/startprobate"));
const Probate = lazy(() => import("@pages/probate/index"));
const EligibilityCheck = lazy(() => import("@pages/probate/Eligibility_1/eligibility"));
const Verification = lazy(() => import("@pages/probate/VerificationDeceasedInfo_2/verificationDeceasedInfo"));
const ApplicationForm = lazy(() => import("@pages/probate/Form_3/form"));
const Assertion = lazy(() => import("../../views/layouts/assertion"));
const DocumentChecklist = lazy(() => import("@pages/probate/DocumentChecklist_4/documentchecklist"));
const ScheduleOfAssets = lazy(() => import("@pages/probate/ScheduleOfAssets_5/scheduleofassets"));
const Submission = lazy(() => import("@pages/probate/Submission_6/submission"));
const AdminOathAndAffidavit = lazy(() => import("@pages/probate/AdministrationOathAndSupplementaryAffidavit_7/adminoathaffidavit"));

const Hearing = lazy(() => import("@pages/probate/Hearing_8/hearing"));
const ExtractionOfGrant = lazy(() => import("@pages/probate/ExtractionOfGrant_9/extractionofgrant"));
const PaymentHistory = lazy(() => import("@pages/payment/History/TransactionHistory"));
const UrlExpired = lazy(() => import("@pages/misc/urlexpired"));
const AllRoutes = () => (

  <Routes>
    <Route  path="/"  element={<HomeLayout />}>
      <Route path="/" element={<Landing />} />
      <Route path="landing" element={<Landing />} />
      <Route path="steps" element={<Probate />} >
        <Route path="eligiblitycheck" element={<EligibilityCheck />} />
      </Route>
      <Route path="assertion" element={<Assertion />} />
      <Route path="urlexpired" element={<UrlExpired />} />
      
    </Route>

    <Route path="/" element={<ProtectedLayout />}>


      <Route path="landing" element={<Landing />} />
      <Route path="apply" element={<StartProbate />} />
      <Route path="paymenthistory" element={<PaymentHistory />} />
      <Route path="urlexpired" element={<UrlExpired />} />
      <Route path="steps" element={<Probate />} >
        <Route path="eligiblitycheck" element={<EligibilityCheck />} />
        <Route path="verification" element={<Verification />} />
        <Route path="applicationform" element={<ApplicationForm />} />
        <Route path="documentchecklist" element={<DocumentChecklist />} />
        <Route path="scheduleofassets" element={<ScheduleOfAssets />} />
        <Route path="submission" element={<Submission />} />
        <Route path="adminoathaffidavit" element={<AdminOathAndAffidavit />} />
        <Route path="hearing" element={<Hearing />} />
        <Route path="extractionofgrant" element={<ExtractionOfGrant />} />

      </Route>
    </Route>
    <Route
      path="*"
      element={
        <>
          <div className="mx-2">Page Not Found!</div>
        </>
      }
    />
  </Routes>
)

export default AllRoutes;
